import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { RazlogPrestankaRo } from './razlog-prestanka-ro';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-razlog-prestanka-ro-update',
  templateUrl: './razlog-prestanka-ro-update.component.html'
})

export class RazlogPrestankaRoUpdateComponent 
extends BaseUpdateComponent<RazlogPrestankaRo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    

    this.addValidatorToFc("Naziv", Validators.required, 'required', 'RAZLOGPRESTANKARO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(5), 'maxlength', 'RAZLOGPRESTANKARO.NAZIV.VALIDATION.MAXLENGTH');
    // this.addValidatorToFc("Naziv", Validators.pattern('[a-z]'), 'pattern', 'NAME.VALIDATION.PATTERN');
  }


}
